import { CalendarViewName } from '~/types'
import { CHANGE_DATES, CHANGE_VIEW, changeDates, changeView } from './actions'

// `dates` starts empty — the calendar fills it in once it knows its range.
export type CalendarState = {
  view: CalendarViewName
  /** FullCalendar's ISO range strings; null until the calendar reports one. */
  dates: { start: string | null; end: string | null }
}
type Action =
  | ReturnType<typeof changeView>
  | ReturnType<typeof changeDates>
  | { type: 'OTHER_ACTION'; payload?: any }

const initialState: CalendarState = {
  view: 'dayGridMonth',
  dates: { start: null, end: null },
}

export * from './actions'
// The Reducer<CalendarState, Action> annotation used to sit on the return type,
// which claimed every dispatch produced another reducer.
/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (previousState = initialState, action: Action): CalendarState => {
  if (action.type === CHANGE_VIEW) {
    return { ...previousState, view: action.payload }
  }
  if (action.type === CHANGE_DATES) {
    return { ...previousState, dates: action.payload }
  }
  return previousState
}
